import ChoosePortal from '../components/common/ChoosePortal';

const Portal = () => <ChoosePortal />;

export default Portal;
